var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 13 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#231F20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.083 17H2.917C2.41 17 2 16.603 2 16.111L1 3.667h11L11 16.11c0 .492-.41.889-.917.889M6.5 1c1.519 0 2.75 1.194 2.75 2.667h0-5.5C3.75 2.194 4.981 1 6.5 1m-1.858 9.58v3.112zV7.47zm3.5 0v3.112zV7.47z"
})));
export default SvgTrash;